var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FF9E00",
    d: "M477.674,127.498c-22.894-39.22-53.945-70.271-93.166-93.164C345.281,11.443,302.457,0,256.008,0 c-46.446,0-89.281,11.443-128.502,34.334c-39.224,22.889-70.276,53.94-93.169,93.164C11.443,166.723,0,209.558,0,256.001 c0,46.444,11.445,89.272,34.333,128.502c22.892,39.22,53.943,70.271,93.168,93.166c39.226,22.89,82.058,34.334,128.502,34.334 c46.443,0,89.28-11.444,128.504-34.334c39.221-22.887,70.271-53.946,93.163-93.166c22.887-39.226,34.327-82.06,34.327-128.502 C512,209.554,500.557,166.719,477.674,127.498z M421.996,217.001L241.001,397.998c-4.224,4.228-9.331,6.339-15.334,6.339 c-5.777,0-10.775-2.111-14.999-6.339L89.996,277.334c-3.995-4.004-5.997-8.993-5.997-14.999c0-6.221,1.995-11.336,5.997-15.337 l30.334-29.997c4.228-4.222,9.221-6.333,15.003-6.333c5.78,0,10.782,2.112,15.003,6.333l75.334,75.332l136-135.665 c4.223-4.224,9.221-6.336,14.999-6.336c5.772,0,10.78,2.112,14.999,6.336l30.334,30.002c4.007,3.997,6.001,9.107,6.001,15.328 C428.003,208,426.009,213.001,421.996,217.001z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M421.996,217.001L241.001,397.998c-4.224,4.228-9.331,6.339-15.334,6.339 c-5.777,0-10.775-2.111-14.999-6.339L89.996,277.334c-3.995-4.004-5.997-8.993-5.997-14.999c0-6.221,1.995-11.336,5.997-15.337 l30.334-29.997c4.228-4.222,9.221-6.333,15.003-6.333c5.78,0,10.782,2.112,15.003,6.333l75.334,75.332l136-135.665 c4.223-4.224,9.221-6.336,14.999-6.336c5.772,0,10.78,2.112,14.999,6.336l30.334,30.002c4.007,3.997,6.001,9.107,6.001,15.328 C428.003,208,426.009,213.001,421.996,217.001z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioChecked);
export default __webpack_public_path__ + "static/media/RadioChecked.adb1d18da69a9826ac6869387de754dc.svg";
export { ForwardRef as ReactComponent };